import '@babel/polyfill';
import 'mutationobserver-shim';
import Vue from 'vue';
import './plugins/bootstrap-vue';
import App from './App.vue';
import axios from 'axios';
import { ValidationObserver, ValidationProvider, extend, localize } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import VueAzureUploader from 'vue-azure-blob-upload';
import Vuelidate from 'vuelidate';
import VueMixpanel from 'vue-mixpanel';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import es from 'vee-validate/dist/locale/es.json';
import translateHelper from './plugins/translate';

//I18N
import i18n from './lang/';

// router setup
import router from './router/index';
import store from '@/store/index';

Vue.use(VueMixpanel, {
  token: '93d74680806d18401e61f01a24d118a2',
});

Vue.config.productionTip = false;
Vue.use(Vuelidate);
Vue.use(VueSweetalert2);

// Vue AzureService
Vue.use(VueAzureUploader);

// prod conn string
//axios.defaults.baseURL = 'https://app-ieladeinu-api-prod-eastus2-01.azurewebsites.net/api/v1'
axios.defaults.baseURL = 'https://app-ieladeinu-api-prod-eastus2-01.azurewebsites.net/api/v1'
//axios.defaults.baseURL = 'http://localhost:3030/api/v1';
Vue.prototype.$bearer = 'Bearer ';
Vue.prototype.$SESION = 'ACCOUNT';

// Vee-validate
Object.keys(rules).forEach((rule) => {
	extend(rule, rules[rule]);
});

localize('es', es);

Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);

Vue.mixin(translateHelper);

new Vue({
	render: (h) => h(App),
	router,
	store,
	VueMixpanel,
	i18n
}).$mount('#app');
